import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { AuthService } from 'src/app/core/services/AuthService';
import { CertificadoService } from 'src/app/core/services/certificado.service';
import { UsuariosService } from 'src/app/core/services/usuarios.service';
import { matchPasswordValidator } from 'src/app/validators/match-password.validator';
import { passwordStrengthValidator } from 'src/app/validators/password-strength.validator';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-form-change-password',
  templateUrl: './form-change-password.component.html',
  styleUrls: ['./form-change-password.component.scss']
})
export class FormChangePasswordComponent {

  @Input() userId!: string;       // ← recibe del padre
  @Input() userName!: string;     // ← si quieres mostrar el nombre o usarlo internamente

  @Input() returnToAdmin: boolean;

  @Output() passwordChanged = new EventEmitter<void>();  // ← para notificar al padre

  public formChangePassword: FormGroup;

  public showCurrentPassword = false;
  public showNewPassword = false;
  public showRepeatNewPassword = false;
  returnUrl = '/dashboard/default';


  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private certificadoService: CertificadoService,
    private usuarioService: UsuariosService,
    private router: Router
  ) {
    this.formChangePassword = this.fb.group({
      currentPassword: new FormControl('', [Validators.required]),
      newPassword: new FormControl('', [Validators.required, passwordStrengthValidator()]),
      repeatPassword: new FormControl('', [Validators.required])
    }, {
      validators: [matchPasswordValidator('newPassword', 'repeatPassword')],
    });
  }

  async changePassword() {
    if (!this.formChangePassword.valid) {
      Swal.fire({
        title: '¡Campos requeridos!',
        text: 'Completa los campos requeridos',
        icon: 'warning',
        confirmButtonText: 'Ok'
      });
      return;
    }

    const { currentPassword, newPassword, repeatPassword } = this.formChangePassword.value;

    if (newPassword.trim() !== repeatPassword.trim()) {
      Swal.fire({
        title: '¡Contraseñas inválidas!',
        text: 'La nueva contraseña no coincide con su repetición',
        icon: 'warning',
        confirmButtonText: 'Ok'
      });
      return;
    }

    const response = await lastValueFrom(
      this.usuarioService.updatePassword(this.userId, { currentPassword, newPassword })
    );

    Swal.fire({
      title: response.message || 'Contraseña actualizada',
      icon: 'success',
      confirmButtonText: 'Ok'
    });

    if (this.returnToAdmin) {
      this.router.navigate([this.returnUrl]);
    }

    this.passwordChanged.emit(); // ← notifica al padre
  }
}
